import styled from 'styled-components';

const SearchWrapper = styled.div`
	.sa-wrapper {
		position: relative;
		.sa-field-handler {
			position: relative;
			right: auto;
			left: 0;
			display: block;
			align-items: center;
			max-width: 320px;
			.multi-select {
				.dropdown-content {
					z-index: 999;
				}
				.dropdown-heading {
					padding-left: 120px;
					max-width: 250px;
					width: 250px;
					height: 30px;
				}
			}
			.sa-options-label {
				-moz-transform: translateX(10px);
				-webkit-transform: translateX(10px);
				-o-transform: translateX(10px);
				-ms-transform: translateX(10px);
				transform: translateX(10px);
				position: absolute;
				left: 0;
				top: 3px;
				z-index: 1;
				pointer-events: none;
			}
		}
		&.master {
			.sa-field-handler {
				position: absolute;
				right: 10px;
				left: auto;
				top: -40px;
				display: flex;
				align-items: center;
				max-width: none;
				.sa-options-label {
					-moz-transform: translateX(110px);
					-webkit-transform: translateX(110px);
					-o-transform: translateX(110px);
					-ms-transform: translateX(110px);
					transform: translateX(110px);
					position: relative;
					z-index: 1;
					left: 0;
					top: 0;
					pointer-events: none;
				}
			}
			.ant-form {
				padding: 10px 15px 0;
				border-bottom: 1px solid #e3e3e3;
				background: #fff;
			}
		}
		&.external {
			.sa-field-handler {
				display: flex;
				align-items: center;
				max-width: none;
			}
			.ant-form {
				margin-top: 10px;
				padding: 10px 15px 0;
				border-bottom: 1px solid #e3e3e3;
				background: #fff;
			}
		}
		.mg-search-panel {
			.multi-select {
				.dropdown-content {
					z-index: 1000;
				}
			}
		}
	}
`;

// &.grid .sa-field-handler {
// 	position: absolute;
// 	right: 30px;
// 	left: auto;
// 	top: -50px;
// 	display: flex;
// 	align-items: center;
// 	max-width: none;
// 	.sa-options-label {
// 		-moz-transform: translateX(110px);
// 		-webkit-transform: translateX(110px);
// 		-o-transform: translateX(110px);
// 		-ms-transform: translateX(110px);
// 		transform: translateX(110px);
// 		position: relative;
// 		z-index: 1;
// 		left: 0;
// 		top: 0;
// 		pointer-events: none;
// 	}
// }

export default SearchWrapper;
